export default __webpack_public_path__ + "static/media/lotus.978772d6.svg";